const subscriptionAccessKeys = {
  // Access Status Messages
  "subscription.access.granted-through-another": "Tu acceso a Be Your Best se ha concedido a través de otra cuenta.",
  "subscription.access.no-active": "No tienes suscripciones activas. Por favor, {{purchaseLink}} para seguir usando Be Your Best.",
  "subscription.access.purchase-link": "compra una suscripción",
  "subscription.access.demo-alert.trial-status": "Actualmente tienes acceso de prueba a Be Your Best.",
  "subscription.access.demo-alert.next-steps": "Próximos pasos → Ve a la Meta Quest App Store y descarga la aplicación Be Your Best en tu casco → Abre la aplicación en tu casco, inicia sesión y comienza a entrenar.",
  "subscription.access.demo-alert.purchase-prompt": "Si quieres la experiencia completa, compra una suscripción {{purchaseLink}}.",
  "subscription.access.demo-alert.link": "aquí",
  "subscription.access.product-expiring": "Tu suscripción de {{productName}} expirará el {{date}}.",
};

export const subscriptionAccess = {
  ...subscriptionAccessKeys,
};
